import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import withConfig from 'with-config';
import ER from 'error-reporting';
import oh from 'output-helpers';

import default_config from './default_config';
import translations from './translations';
import Login from './views/Login';
import AutoLogin from './views/AutoLogin';
import Logout from './views/Logout';
import ForgotPassword from './views/ForgotPassword';
import ResetPassword from './views/ResetPassword';
import StyledBase from './theme/StyledBase';

declare global {
    interface Window {
        sso: any;
        Promise: any;
        Modernizr: any;
    }
}

const ReportingWrapper: React.FunctionComponent = props => {
    return <>{props.children}</>;
};

withConfig.setDefault(default_config);
withConfig.get().then(config => {
    let error_report_config = {
        header: 'SSO UI: ',
        slack_webhook: config.slack.webhook_uri,
        disable_slack_posting:
            !config.send_errors_to_slack_in_dev && !config.production,
    };

    ER.setConfig(error_report_config);
});

oh.setConfig({
    lang: default_config.default_language,
});
oh.addDictionary(translations);

let ReportingWrapperWithER = ER.withErrorReporting(
    ReportingWrapper,
    ER.ErrorAlert,
    () => {
        let prefix = 'User not logged in.';

        if (window.sso && window.sso.isLoggedIn && window.sso.isLoggedIn()) {
            let token = window.sso.getJWT();
            let token_issued = new Date(token.getClaim('iat') * 1000);
            prefix =
                'User ' +
                token.getClaim('uid') +
                '/' +
                token.getClaim('username') +
                ' iat@' +
                token_issued.toISOString();
        }

        let status = ER.getStatus();
        let err = ER.getError();
        let label = oh.translate('sending');
        let body: string[] = [];
        if (err.display_text) {
            body.concat(err.display_text);
        }
        if (status === 'sent') {
            label = oh.translate('sent');
            body.concat(oh.translate('error_report_sent'));
        } else if (status === 'failed') {
            label = oh.translate('failed');
            body = [
                oh.translate('error_report_failed'),
                oh.translate('please_contact_us'),
            ];
        } else {
            body.concat(oh.translate('sending_error_report'));
        }

        return {
            prefix: prefix,
            custom_error_props: {
                title: oh.translate('error_has_occured'),
                label: label,
                body: body,
                action_label: err.action_label || oh.translate('go_to_start'),
                actionCB: () => {
                    err.actionCB
                        ? err.actionCB()
                        : (window.location.href = '/');
                },
            },
        };
    },
);
ReportingWrapperWithER = withConfig(ReportingWrapperWithER);

ReactDOM.render(
    <Router>
        <StyledBase>
            <ReportingWrapperWithER>
                <Route exact path="/" component={Login} />
                <Route exact path="/v2" component={Login} />
                <Route path="/login" component={AutoLogin} />
                <Route path="/logout" component={Logout} />
                <Route path="/forgot-password" component={ForgotPassword} />
                <Route path="/reset-password" component={ResetPassword} />
                <Route path="/v2/login" component={AutoLogin} />
                <Route path="/v2/logout" component={Logout} />
                <Route path="/v2/forgot-password" component={ForgotPassword} />
                <Route path="/v2/reset-password" component={ResetPassword} />
            </ReportingWrapperWithER>
        </StyledBase>
    </Router>,
    document.getElementById('root') as HTMLElement,
);



// WEBPACK FOOTER //
// ./src/index.tsx